var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDispatcher2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}.cls-2{fill:currentColor;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M58.09,129.5a12.7,12.7,0,0,1-8,2.83h0a12.85,12.85,0,0,1-12.81-12.81V96.92A12.84,12.84,0,0,1,50.09,84.11h0a12.77,12.77,0,0,1,8,2.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M155.66,86.94a12.75,12.75,0,0,1,8-2.83h0a12.85,12.85,0,0,1,12.81,12.81v22.6a12.85,12.85,0,0,1-12.81,12.81h0a12.72,12.72,0,0,1-8-2.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51.53,82.2A60.26,60.26,0,0,1,163,82.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M165.09,132.65a28.72,28.72,0,0,1-29.42,24.11"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 105.37,
    y: 147.86,
    width: 29.1,
    height: 18.46,
    rx: 9.23
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M104.72,159.31a50.14,50.14,0,1,1,28.39-7.2"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 97.01,
    cy: 108.54,
    r: 4.78
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 117.19,
    cy: 108.54,
    r: 4.78
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M56.93,106.91c37.14-5.53,64.83-31.6,64.83-31.6s15.64,26.39,34.54,34.21"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDispatcher2);
export default __webpack_public_path__ + "static/media/DISPATCHER_2.9e0dfb270e1d9893c19f2a9553ececf8.svg";
export { ForwardRef as ReactComponent };